import { render, staticRenderFns } from "./ProjectAboutDialog.vue?vue&type=template&id=4edf8cb6&scoped=true"
import script from "./ProjectAboutDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAboutDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf8cb6",
  null
  
)

export default component.exports